import { render, staticRenderFns } from "./returnpurchasePay.vue?vue&type=template&id=556a2c9a&scoped=true&"
import script from "./returnpurchasePay.vue?vue&type=script&lang=js&"
export * from "./returnpurchasePay.vue?vue&type=script&lang=js&"
import style0 from "./returnpurchasePay.vue?vue&type=style&index=0&id=556a2c9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a2c9a",
  null
  
)

export default component.exports